export function formatObject(obj) {
  return {
    derivacionId: obj.derivacionId,
    notaDePedidoId: obj.notaDePedidoId,
    candidatosDetalle: obj.idsCandidatos.map((id) => ({
      estado: obj.estado,
      id,
      fechaDeIngreso: obj.fechaDeIngreso,
      motivo: obj.motivo,
      motivoOtro: obj.motivoOtro,
    })),
  };
}

export const getEstadoByValue = (value, categories) => {
  if (categories) {
    const category = categories.find((cat) => cat.id === value);
    return category ? category.text : "";
  }
  return "";
};

export const validateEmail = (e) => {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return re.test(e);
};

export function formatearFecha(fecha) {
  // de YYYY-MM-DD a DD/MM/YYYY
  const [year, month, day] = fecha.split("-");
  return `${day}/${month}/${year.slice(-2)}`;
}

export const getMotivoNoAvanza = (motivo, lista, motivoOtro) => {
  let motivoToShow = "";
  if (motivo && lista) {
    const currentMotivo = lista.find((e) => e.id === motivo);
    if (motivo === 15) {
      motivoToShow = `${currentMotivo.motivo} - ${motivoOtro}`;
    } else {
      motivoToShow = `${currentMotivo.motivo} - ${currentMotivo.subMotivo}`;
    }
  }
  return motivoToShow;
};
